import { Link } from '@tanstack/react-router';
import { signIn } from '@/lib/cloudflare/auth-client';
import { buildGettingStartedPath } from '@/lib/cloudflare/billing-client';
import { usePostHog } from 'posthog-js/react';

export function StaticNav() {
  const posthog = usePostHog();

  const handleSignIn = () => {
    if (posthog) {
      posthog.capture('clicked_get_started', { location: 'navbar' });
    }
    signIn(buildGettingStartedPath());
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 w-full bg-[#fafafa]">
      <div className="flex h-14 items-center justify-between px-6">
        <div className="flex items-center gap-3">
          <Link to="/">
            <img src="/logo.svg" alt="Winbox Zero" className="h-6 w-auto" />
          </Link>
          <span className="text-sm font-medium tracking-[-0.01em] text-slate-600">
            <Link to="/" className="font-semibold text-slate-900 hover:text-slate-700 transition-colors">Winbox Zero</Link> gets you to inbox zero every morning
          </span>
        </div>

        <div className="flex items-center gap-6">
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/features" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Features</Link>
            <Link to="/pricing" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Pricing</Link>
          </nav>

          <button
            onClick={handleSignIn}
            className="inline-flex items-center gap-2 h-10 rounded-full border border-slate-200 bg-white px-5 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:border-slate-300 transition-all shadow-sm"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Get started
          </button>
        </div>
      </div>
    </header>
  );
}
